import { CSpinner } from '@coreui/react'
import React, { useState, useEffect } from 'react'
import { changePassword } from 'src/services/Auth/AuthService'
import { useNavigate } from 'react-router-dom'
import { SHA512, AES } from 'crypto-js'
import CryptoJS from 'crypto-js'
import Tostify, { showToast } from 'src/utils/Tostify'
import { FaEye, FaEyeSlash, FaLock } from 'react-icons/fa'
import LogoHeader from 'src/components/header/LogoHeader'

const generateSHA512HashAndEncryptInES6 = (data) => {
  const hash = SHA512(data)
  const hashResult = hash.toString()
  const encryptedText = AES.encrypt(hashResult, process.env.REACT_APP_KEY).toString()
  return encryptedText
}

const generateES6Hash = (data) => {
  const encryptedText = CryptoJS.AES.encrypt(data, process.env.REACT_APP_KEY).toString()
  return encryptedText
}

function FirstTimeChangePassword() {
  const [loading, setLoading] = useState(false)
  const [showOldPassword, setShowOldPassword] = useState(false)
  const [showNewPassword, setShowNewPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)

  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    oldPassword: '',
    newPassword: '',
    confirmNewPassword: '',
  })

  const [errors, setErrors] = useState({
    old_password: '',
    new_password: '',
    confirm_password: '',
    same_password: '',
  })

  const toggleShowOldPassword = () => {
    setShowOldPassword(!showOldPassword)
  }

  const toggleShowNewPassword = () => {
    setShowNewPassword(!showNewPassword)
  }

  const toggleShowConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword)
  }

  const handleChange = (event) => {
    const { name, value } = event.target

    setFormData({ ...formData, [name]: value })

    const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/

    switch (name) {
      case 'oldPassword':
        setErrors({
          ...errors,
          old_password: value.length > 0 ? '' : 'Old password is required',
        })
        break

      case 'newPassword':
        setErrors({
          ...errors,
          new_password: passwordPattern.test(value)
            ? ''
            : 'Minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character',
        })
        break

      case 'confirmNewPassword':
        setErrors({
          ...errors,
          confirm_password: value === formData.newPassword ? '' : 'Passwords do not match',
          same_password:
            formData.oldPassword === value ? 'New password cannot be the same as old password' : '',
        })
        break

      default:
        break
    }
  }

  useEffect(() => {
    const token = localStorage.getItem('token')

    if (!token) {
      navigate('/login')
    }
  }, [navigate])

  const handleSubmit = async (e) => {
    e.preventDefault()
    const newErrors = { old_password: '', new_password: '', same_password: '' }
    if (!formData.oldPassword) {
      newErrors.old_password = 'Old Password is required'
    }

    if (!formData.newPassword) {
      newErrors.new_password = 'New Password is required'
    }

    if (!formData.confirmNewPassword) {
      newErrors.confirm_password = 'Confirm Password is required'
    }
    if (formData.newPassword !== formData.confirmNewPassword) {
      newErrors.same_password = 'New password and confirm password do not match'
      setFormData('')
    } else {
      setErrors({
        confirm_password: '',
      })
    }

    setErrors(newErrors)
    if (!newErrors.old_password && !newErrors.new_password && !newErrors.same_password) {
      const encryptedData = {
        oldPassword: generateSHA512HashAndEncryptInES6(formData.oldPassword),
        newPassword: generateES6Hash(formData.newPassword),
        confirmNewPassword: generateES6Hash(formData.confirmNewPassword),
      }
      setLoading(true)
      const response = await changePassword(encryptedData)
      setLoading(false)
      if (response.success) {
        localStorage.clear()
        showToast('Password Changed Successfully\n Please Login Again', 'success')
        setFormData({
          oldPassword: '',
          newPassword: '',
          confirmNewPassword: '',
        })
        setTimeout(() => {
          navigate('/login')
        }, 2000)
      } else {
        showToast(response.message, 'error')
      }
    }
  }

  const inputGroupTextStyle = {
    backgroundColor: '#F3F4F6',
    border: '1px solid #E5E7EB',
    borderRight: 'none',
  }

  const inputStyle = {
    padding: '10px 14px',
    border: '1px solid #E5E7EB',
    borderLeft: 'none',
    borderRight: 'none',
  }

  const eyeToggleStyle = {
    backgroundColor: '#F3F4F6',
    border: '1px solid #E5E7EB',
    borderLeft: 'none',
    cursor: 'pointer',
  }

  const lockIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="16" height="16" role="img" aria-hidden="true">
      <path
        fill="#3C4B64"
        d="M384,200V144a128,128,0,0,0-256,0v56H88V328c0,92.635,75.364,168,168,168s168-75.365,168-168V200ZM160,144a96,96,0,0,1,192,0v56H160ZM392,328c0,74.99-61.01,136-136,136s-136-61.01-136-136V232H392Z"
      ></path>
    </svg>
  )

  return (
    <>
      <div className="card" style={{ border: 'none', borderRadius: 0 }}>
        <LogoHeader />
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '70vh',
          backgroundColor: '#f4f4f4',
          padding: '2rem 1rem',
        }}
      >
        <div
          style={{
            width: '100%',
            maxWidth: '460px',
            backgroundColor: '#ffffff',
            borderRadius: '18px',
            boxShadow: '0 12px 32px rgba(0, 0, 0, 0.1)',
            overflow: 'hidden',
          }}
        >
          <div
            style={{
              backgroundColor: '#3C4B64',
              padding: '24px 28px',
              display: 'flex',
              alignItems: 'center',
              gap: '14px',
            }}
          >
            <div
              style={{
                width: '48px',
                height: '48px',
                minWidth: '48px',
                borderRadius: '50%',
                backgroundColor: '#4d5f7c',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <FaLock size={20} color="#ffffff" />
            </div>
            <div>
              <p style={{ color: '#ffffff', fontSize: '1.1rem', fontWeight: 700, margin: 0 }}>
                Change Password
              </p>
              <p style={{ color: '#C9D1DB', fontSize: '0.8rem', margin: 0 }}>
                Please set a new password
              </p>
            </div>
          </div>

          <div style={{ padding: '28px' }}>
            <form onSubmit={handleSubmit}>
              <div className="input-group mb-3">
                <span className="input-group-text" style={inputGroupTextStyle}>
                  {lockIcon}
                </span>
                <input
                  type={showOldPassword ? 'text' : 'password'}
                  name="oldPassword"
                  value={formData.oldPassword}
                  onChange={handleChange}
                  className={`form-control ${errors.old_password ? 'is-invalid' : ''}`}
                  placeholder="Old Password"
                  autoComplete="current-password"
                  style={inputStyle}
                  required={true}
                />
                <span
                  className="input-group-text"
                  onClick={toggleShowOldPassword}
                  style={eyeToggleStyle}
                  aria-label={showOldPassword ? 'Hide old password' : 'Show old password'}
                >
                  {showOldPassword ? <FaEyeSlash color="#6B7280" /> : <FaEye color="#6B7280" />}
                </span>
                {errors.old_password && (
                  <div className="invalid-feedback">{errors.old_password}</div>
                )}
              </div>

              <div className="input-group mb-3">
                <span className="input-group-text" style={inputGroupTextStyle}>
                  {lockIcon}
                </span>
                <input
                  type={showNewPassword ? 'text' : 'password'}
                  name="newPassword"
                  value={formData.newPassword}
                  onChange={handleChange}
                  className={`form-control ${errors.new_password ? 'is-invalid' : ''}`}
                  placeholder="New Password"
                  autoComplete="new-password"
                  pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$"
                  style={inputStyle}
                  required={true}
                />
                <span
                  className="input-group-text"
                  onClick={toggleShowNewPassword}
                  style={eyeToggleStyle}
                  aria-label={showNewPassword ? 'Hide new password' : 'Show new password'}
                >
                  {showNewPassword ? <FaEyeSlash color="#6B7280" /> : <FaEye color="#6B7280" />}
                </span>
                {errors.new_password && (
                  <div className="invalid-feedback">{errors.new_password}</div>
                )}
              </div>

              <div className="input-group mb-3">
                <span className="input-group-text" style={inputGroupTextStyle}>
                  {lockIcon}
                </span>
                <input
                  type={showConfirmPassword ? 'text' : 'password'}
                  name="confirmNewPassword"
                  value={formData.confirmNewPassword}
                  onChange={handleChange}
                  className={`form-control ${errors.confirm_password ? 'is-invalid' : ''}`}
                  placeholder="Confirm Password"
                  autoComplete="new-password"
                  pattern={formData.newPassword}
                  style={inputStyle}
                  required={true}
                />
                <span
                  className="input-group-text"
                  onClick={toggleShowConfirmPassword}
                  style={eyeToggleStyle}
                  aria-label={showConfirmPassword ? 'Hide confirm password' : 'Show confirm password'}
                >
                  {showConfirmPassword ? <FaEyeSlash color="#6B7280" /> : <FaEye color="#6B7280" />}
                </span>
                {errors.confirm_password && (
                  <div className="invalid-feedback">{errors.confirm_password}</div>
                )}
                {errors.same_password && (
                  <div className="invalid-feedback">{errors.same_password}</div>
                )}
              </div>

              <button
                className="btn w-100"
                style={{
                  backgroundColor: '#3c4b64',
                  color: 'white',
                  borderRadius: '8px',
                  padding: '10px',
                  fontWeight: 500,
                  boxShadow: '0 4px 12px rgba(60, 75, 100, 0.25)',
                }}
                type="submit"
                disabled={
                  !formData.oldPassword ||
                  !formData.newPassword ||
                  !formData.confirmNewPassword ||
                  formData.newPassword !== formData.confirmNewPassword ||
                  errors.confirm_password ||
                  errors.new_password ||
                  errors.old_password ||
                  loading
                }
              >
                {loading ? (
                  <>
                    <CSpinner component="span" size="sm" aria-hidden="true" />
                  </>
                ) : (
                  'Change Password'
                )}
              </button>
            </form>

            <div
              style={{
                marginTop: '16px',
                padding: '12px 16px',
                backgroundColor: '#FEF2F2',
                border: '1px solid #FECACA',
                borderRadius: '10px',
              }}
            >
              <ul style={{ listStyle: 'square', color: 'red', fontSize: '13px', marginTop: 0, marginBottom: 0, paddingLeft: '18px' }}>
                <strong>Please note that the password should have:</strong>
                <li> At least 8 characters</li>
                <li>At least one uppercase letter</li>
                <li>At least one lowercase letter</li>
                <li>At least one number</li>
                <li>No White Spaces </li>
                <li>One of the digits should be a special character ( i.e. @,#,$,? etc)</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <Tostify />
    </>
  )
}

export default FirstTimeChangePassword